import React, { useMemo } from 'react';
import { ITabItem } from 'components/tab';
import { BaseSidePanel } from 'components/sidePanel';
import FiltersContainer from './FiltersContainer';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { FilterViews } from '../constants';
import { useRMDispatch } from 'redux/hooks';
import {
  selectAllSearchFilterValues,
  setPrimaryFilter,
  toggleEnableFilters,
} from 'redux/reducers/searchnFilterReducer';
import { useSearchFilters } from 'redux/hooks/searchnFilter';
import { usePrimaryFilterEffect } from '../hooks';

interface Props {
  setContentViewState: (view: FilterViews) => void;
}

const FiltersPanel = (props: Props) => {
  const dispatch = useRMDispatch();
  const filters = useSearchFilters();
  usePrimaryFilterEffect();

  const onSelectAll = () => {
    dispatch(setPrimaryFilter(undefined));
    dispatch(selectAllSearchFilterValues());
  };

  const setPrimaryFilterHandler = (filterId: number | undefined) => {
    dispatch(setPrimaryFilter(filterId));
  };

  const rightSideButtonProps: RMCustomButtonProps[] = [
    {
      title: 'SELECT ALL',
      contentContainerClass:
        'text-white bg-black w-[96px] h-[26px] p-t-[4px] p-r-[10px] p-b-[4px] p-l-[10px] gap-2 font-roboto font-medium leading-[18px] ',
      onClick: onSelectAll,
      isDisabled: false,
    },
  ];

  const tabItems_: ITabItem[] = [
    {
      content: (
        <FiltersContainer
          filters={filters}
          primaryFilterId={filters.primaryFilter}
          setPrimaryFilterId={setPrimaryFilterHandler}
        />
      ),
      title: 'Filter',
    },
  ];

  const onChangeEnableFilters = () => {
    dispatch(toggleEnableFilters());
  };

  const ExtraOptions: IDropDownList[] = useMemo(
    () => [
      {
        label: 'Enable Filters',
        onClick: onChangeEnableFilters,
        isDisabled: false,
        itemClass: 'h-[3.5vh] w-full',
        ...(filters.enableFilters ? { iconProps: { name: 'checkMark' } } : {}),
      },
    ],
    [filters],
  );

  return (
    <BaseSidePanel
      tabItems={tabItems_}
      headerTitle={'Filter'}
      actionButtonsProps={rightSideButtonProps}
      actionsLIst={ExtraOptions}
    />
  );
};

export default FiltersPanel;
